import React, { FC } from 'react';
import { useSubNavigationConfig } from './config';

import NestedMenu from '../NestedMenu';

type SubNavigationProps = {
  nestedMenuVariant?: 'sidebar';
};

const SubNavigation: FC<SubNavigationProps> = ({
  nestedMenuVariant,
}) => {
  const configItems = useSubNavigationConfig();

  return (
    <NestedMenu
      items={configItems}
      variant={nestedMenuVariant}
    />
  );
};

export default SubNavigation;
